import { differenceInYears } from 'date-fns';

export const getGenerationString = (birthday: Date): Maybe<string> => {
  const age = differenceInYears(new Date(), birthday);
  const generation = Math.trunc(age / 10) * 10;
  // 0歳から9歳までのプランナーはいない前提
  return generation >= 10 ? `${generation}代` : undefined;
};
